module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"summary_phase":"Phase:","summary_status":"Status:"},"fr":{"summary_phase":"Phase:","summary_status":"Status:"}}')
  delete Component.options._Ctor
}
